export default "__VITE_ASSET__72a10127__"